const initialState = {
  isInitialized: false,
};

const reducerName = 'Websockets';
const websocketsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'Get'.concat(reducerName):
      return state;
    case 'Insert'.concat(reducerName):
      return {
        isInitialized: action.payload?.isInitialized,
      };
    default:
      return state;
  }
};

export default websocketsReducer;
